/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_TitleInputs */

const en_video_export_title = /** @type {(inputs: Video_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Export`)
};

const fr_video_export_title = /** @type {(inputs: Video_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation video`)
};

const de_video_export_title = /** @type {(inputs: Video_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoexport`)
};

const it_video_export_title = /** @type {(inputs: Video_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione video`)
};

const ru_video_export_title = /** @type {(inputs: Video_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт видео`)
};

const es_video_export_title = /** @type {(inputs: Video_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de vídeo`)
};

const zh_cn2_video_export_title = /** @type {(inputs: Video_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频导出`)
};

const ja_video_export_title = /** @type {(inputs: Video_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオエクスポート`)
};

const hi_video_export_title = /** @type {(inputs: Video_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात`)
};

const pt_pt2_video_export_title = /** @type {(inputs: Video_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação de vídeo`)
};

/**
* | output |
* | --- |
* | "Video Export" |
*
* @param {Video_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_title = /** @type {((inputs?: Video_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_title(inputs)
	if (locale === "de") return de_video_export_title(inputs)
	if (locale === "it") return it_video_export_title(inputs)
	if (locale === "ru") return ru_video_export_title(inputs)
	if (locale === "es") return es_video_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_title(inputs)
	if (locale === "ja") return ja_video_export_title(inputs)
	if (locale === "hi") return hi_video_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_title(inputs)
	return en_video_export_title(inputs)
});